<template>
    <section>
        <section v-if="submittal">
            <div class="responsive">
                <div class="responsive-pane">
                    <div class="responsive-inner">
                        <table class="review">
                            <thead>
                            <tr>
                                <th>Reorder</th>
                                <th>Figure Number</th>
                                <th>Product Name</th>
                                <th>Product Line</th>
                                <th>Datasheet</th>
                                <th>Delete</th>
                            </tr>
                            </thead>

                            <draggable
                                v-model="results"
                                :element="'tbody'"
                                @update="update"
                                v-if="showProducts"
                                >
                                <tr v-for="result in results" :key="result.productId">
                                    <td class="icon move"><i class="fa fa-bars"></i></td>
                                    <td class="preview-image">
                                        <span v-text="result.figureNumber"></span>
                                        <div>
                                            <img :src="result.image" :alt="result.figureNumber">
                                        </div>
                                    </td>
                                    <td v-text="result.name"></td>
                                    <td v-text="result.productLine"></td>
                                    <td class="icon">
                                        <modal :result="result"></modal>
                                    </td>
                                    <td class="icon">
                                        <confirm
                                                :result="result"
                                                :submittalID="submittalID"
                                                @refresh="refresh"
                                                tooltip="Delete Product"></confirm>
                                    </td>
                                </tr>
                            </draggable>

                            <tr v-else>
                                <td colspan="6">
                                    <p class="no-products">
                                        There are no products currently added to this submittal.
                                        <router-link :to="{ path: 'browse' }" :class="['back']">Browse products</router-link>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="confirm">
                <div>
                    <router-link :to="{ path: 'browse' }" :class="['button alternate simple back']">Browse</router-link>
                </div>
                <div>
                    <save-button :saving="saving" @clicked="save"></save-button>
                    <button type="submit" @click="next">Next</button>
                </div>
            </div>

        </section>
        <loading v-else></loading>
    </section>
</template>

<script>
    import ReviewModal from 'vue/submittal-manager/mechanical/review/_modal';
    import Confirm from 'vue/submittal-manager/mechanical/review/_confirm-delete';
    import VueDraggable from 'vuedraggable';
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import _ from 'lodash'

    export default {
        data() {
            return {
                saving: false,
                sortOrder: [],
                updated: false
            }
        },
        components: {
            'modal': ReviewModal,
            'draggable': VueDraggable,
            'confirm': Confirm
        },
        computed: {
            showProducts() {
                return this.results.length > 0;
            },
            results: {
                get() {
                    return _.toArray(this.products);
                },
                set(value) {
                    this.reorderProducts(value)
                }
            },

            ...mapGetters('mechanical', [
                'products',
                'submittal'
            ])
        },
        methods: {
            save() {
                this.saving = true;

                this.saveOrder(this.submittalID).then(() => {
                    this.updated = false;
                    this.getSubmittalInfo(this.submittalID);
                })
                .then(() => {
                    this.saving = false;
                });
            },
            next() {

                if (!this.updated) {
                    this.$router.push({'name': 'mechanical-report', params: {'submittalID': this.submittalID}});
                    return;
                }

                this
                .saveOrder(this.submittalID)
                .then(() => {
                    this.$router.push({'name': 'mechanical-report', params: {'submittalID': this.submittalID}});
                });

            },
            update() {
                this.updated = true;
            },
            refresh() {
                this.getSubmittalInfo(this.submittalID);
            },

            ...mapMutations('mechanical', [
                'reorderProducts'
            ]),

            ...mapActions('mechanical', [
                'saveOrder',
                'getSubmittalInfo',
                'editSubmittalInfo',
            ])
        },
        created() {
            this.getSubmittalInfo(this.submittalID);
        },
        props: ['submittalID'],
    }
</script>
